import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./OurPrograms.css";

import image1 from "../../assets/Enrichment-mix.jpeg";
import image2 from "../../assets/Education-mix.jpeg";
import image3 from "../../assets/Empowerment-mix.jpeg";
import image4 from "../../assets/impact-stories-mix.jpeg";

import bannerImage from "../../assets/banners-program.avif";

const OurProgramsPage = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.hash.replace("#", "");
    if (sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        const yOffset = -120;
        const y =
          section.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div>
      {/* Banner Section */}
      <div
        className="about-banner d-flex align-items-center justify-content-center"
        style={{
          backgroundImage: `url(${bannerImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "400px",
        }}
      >
        <Container>
          <h1 className="text-white text-center">Our Program</h1>
        </Container>
      </div>
      <div className="our-program-page">
        <Container fluid>
          {/* ENRICHMENT */}
          <Row
            id="enrichment"
            className="program-content-block align-items-center"
          >
            <Col md={8}>
              <h2>Enrichment</h2>
              <h5 className="text-muted mb-3">
                Restoring Lives Through Food and Healthcare
              </h5>
              <p>
                No one should suffer from hunger or untreated illness yet
                millions still do. At our foundation, we respond to this crisis
                with purpose. We deliver timely food, medicine, and care to
                communities that need it the most, ensuring their basic dignity
                is never forgotten.
              </p>
              <p>
                Through strong partnerships, local outreach, and the dedication
                of our volunteers, we aim to bridge the gap between survival and
                support not just once, but consistently.
              </p>

              <ul className="program-bullets">
                <li>
                  Daily Food Drives: Nutritious meals for children, elderly, and
                  homeless
                </li>
                <li>
                  Ration Kits: Monthly grocery support for struggling families
                </li>
                <li>
                  Free Medicines: Distribution of essential medicines and
                  supplies
                </li>
                <li>
                  Medical Camps: Regular health checkups and doctor
                  consultations
                </li>
                <li>
                  Hygiene Awareness: Campaigns on cleanliness and personal care
                </li>
                <li>
                  Mental Wellbeing Support: Emotional care for children and
                  elders
                </li>
              </ul>
            </Col>
            <Col md={4}>
              <Image src={image1} alt="Enrichment" className="program-image" />
            </Col>
          </Row>

          {/* EDUCATION */}
          <Row
            id="education"
            className="program-content-block align-items-center flex-row-reverse"
          >
            <Col md={8}>
              <h2>Education</h2>
              <h5 className="text-muted  mb-3">
                Empowering Young Minds Through Learning
              </h5>
              <p>
                Every child deserves the chance to learn, grow, and build a
                better future. Yet for many, education remains a distant dream
                due to poverty and lack of access.
              </p>
              <p>
                That’s why we work tirelessly to remove those barriers by
                offering learning spaces, school supplies, mentorship, and
                digital literacy to help children thrive both in and beyond the
                classroom.
              </p>
              <ul className="program-bullets">
                <li>
                  Free Schooling: Admission support and tuition sponsorships for
                  underprivileged children
                </li>
                <li>
                  Study Materials: Distribution of books, uniforms, and
                  stationery
                </li>
                <li>
                  After-School Support: Learning centers with tutors for
                  homework and exam prep
                </li>
                <li>
                  Digital Literacy: Basic computer education for children and
                  youth
                </li>
                <li>
                  Scholarships: Financial aid for meritorious students from
                  low-income families
                </li>
                <li>
                  Life Skills Training: English speaking, communication, and
                  problem-solving skills
                </li>
              </ul>
            </Col>
            <Col md={4}>
              <Image src={image2} alt="Education" className="program-image" />
            </Col>
          </Row>

          {/* EMPOWERMENT */}
          <Row
            id="empowerment"
            className="program-content-block align-items-center"
          >
            <Col md={8}>
              <h2>Empowerment</h2>
              <h5 className="text-muted mb-3">
                Creating Self-Reliance Through Skills and Opportunity
              </h5>
              <p>
                Empowerment isn’t just about support it’s about giving people
                the tools to stand on their own. When individuals gain skills,
                knowledge, and confidence, they begin to change their future
                with their own hands.
              </p>
              <p>
                Our programs focus on upskilling youth, supporting women, and
                guiding small entrepreneurs to build sustainable income sources
                and regain control of their lives.
              </p>

              <ul className="program-bullets">
                <li>
                  Vocational Training: Tailoring, handicrafts, and home-based
                  skill development
                </li>
                <li>
                  Women Empowerment Workshops: Self-help groups, financial
                  literacy, and leadership building
                </li>
                <li>
                  Entrepreneurship Support: Small business training and seed
                  funding for micro-entrepreneurs
                </li>
                <li>
                  Digital Skills: Online tools, mobile literacy, and freelancing
                  guidance
                </li>
                <li>
                  Financial Education: Budgeting, saving, and access to
                  micro-loans
                </li>
                <li>
                  Confidence Building: Soft skills, resume help, and
                  job-readiness coaching
                </li>
              </ul>
            </Col>
            <Col md={4}>
              <Image src={image3} alt="Empowerment" className="program-image" />
            </Col>
          </Row>

          {/* IMPACT STORIES */}
          <Row
            id="impact-stories"
            className="program-content-block align-items-center flex-row-reverse"
          >
            <Col md={8}>
              <h2>Impact Stories</h2>
              <h5 className="text-muted">Real People. Real Change.</h5>
              <p>
                Behind every number is a name, a face, a life transformed. Here
                are a few stories that remind us why we do what we do.
              </p>

              <div className="impact-story-card">
                <h6>Rani’s Journey to School</h6>
                <p>
                  Rani, a 9-year-old girl from a remote village, had never seen
                  the inside of a classroom. With support from our education
                  program, she received books, a uniform, and her first
                  schoolbag. Today, she reads fluently and dreams of becoming a
                  teacher.
                </p>
              </div>

              <div className="impact-story-card">
                <h6>Latha’s New Beginning</h6>
                <p>
                  After losing her husband, Latha had no source of income.
                  Through our tailoring training, she learned stitching and
                  started a small home-based business. Now, she not only
                  supports her two children but also trains other women in her
                  village.
                </p>
              </div>

              <div className="impact-story-card">
                <h6>Arjun Finds His First Job</h6>
                <p>
                  Arjun dropped out of school and struggled to find work. Our
                  digital literacy course helped him learn basic computer skills
                  and build confidence. Today, he works as a data entry
                  assistant at a local office.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <Image
                src={image4}
                alt="Impact Stories"
                className="program-image"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default OurProgramsPage;
